// extracted by mini-css-extract-plugin
module.exports = {"spec":"Spec_spec__c49t_"};